export default function() {
  const mediaItems = [
    /*{
      name: "play",
      icon: "play_control",
      path: routes.home,
      title: i18n.get("global.mediaControls.play"),
  
    },
    {
      
      name: "trailer",
      icon: "trailer_control",
      path: routes.home,
      title: i18n.get("global.mediaControls.trailer"),
     
    },
    
    {
      name: "info",
      icon: "info_control",
      path: routes.home,
      title: i18n.get("global.mediaControls.info"),
    },*/
  ];
  return mediaItems;
}
